var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "testPaperWrap" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { staticClass: "content_box" }, [
        _c(
          "main",
          { attrs: { id: "wrapMain" } },
          [
            _c("Left", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowLeft,
                  expression: "isShowLeft"
                }
              ]
            }),
            _vm._v(" "),
            _c("Right", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowLeft,
                  expression: "isShowLeft"
                }
              ],
              staticStyle: { flex: "1" }
            }),
            _vm._v(" "),
            !_vm.isShowLeft && _vm.isShow
              ? _c("div", { staticClass: "paperIframeBox" }, [
                  _c(
                    "div",
                    {
                      ref: "paperIframe",
                      staticClass: "paperIframe",
                      style: _vm.paperIframeStyle
                    },
                    [
                      _c("iframe", {
                        staticStyle: { height: "100%", width: "100%" },
                        attrs: { src: _vm.paperIframe }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isDrag,
                            expression: "isDrag"
                          }
                        ],
                        staticClass: "paperIframe_mask"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.childrenShow,
                        expression: "childrenShow"
                      }
                    ],
                    staticClass: "paperDrapLine",
                    on: {
                      mousedown: function($event) {
                        $event.stopPropagation()
                        return _vm.iframeLineMove($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.childrenShow,
                          expression: "childrenShow"
                        }
                      ],
                      staticClass: "childrenIframe"
                    },
                    [
                      _c("iframe", {
                        staticStyle: { height: "100%", width: "100%" },
                        attrs: { src: _vm.childrenIframe }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isDrag,
                            expression: "isDrag"
                          }
                        ],
                        staticClass: "paperIframe_mask"
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "el-icon-circle-close paperChildClose",
                        on: { click: _vm.closeChildIfamre }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.isShowIframe
          ? _c(
              "div",
              { staticClass: "paperIrameTools", attrs: { id: "frame" } },
              [
                _c("div", { staticClass: "top" }, [
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "span",
                        { staticStyle: { float: "left", "margin-top": "5px" } },
                        [_vm._v("布局：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { float: "left" },
                          on: { change: _vm.layoutChange },
                          model: {
                            value: _vm.layout,
                            callback: function($$v) {
                              _vm.layout = $$v
                            },
                            expression: "layout"
                          }
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "上下" } }),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "左右" } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            float: "left",
                            "margin-top": "5px",
                            "margin-left": "10px"
                          }
                        },
                        [_vm._v("分屏：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { float: "left" },
                          on: { change: _vm.splited },
                          model: {
                            value: _vm.split,
                            callback: function($$v) {
                              _vm.split = $$v
                            },
                            expression: "split"
                          }
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "3:1" } }),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "2:1" } }),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "1:1" } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "peperChildrenEventBtn" },
                  [
                    _vm.childrenUrls.length
                      ? _vm._l(_vm.childrenUrls, function(
                          childItem,
                          childIndex
                        ) {
                          return _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "bury",
                                  rawName: "v-bury",
                                  value: { start: true },
                                  expression: "{ start: true }"
                                }
                              ],
                              key: childIndex + "child",
                              staticClass: "zl_button zl_blueButton",
                              staticStyle: { margin: "5px" },
                              on: {
                                click: function($event) {
                                  return _vm.peperChildrenEvent(childItem)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.buttonName[childItem.platform] ||
                                      childItem.platform
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        })
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "editorShowArea ql-editor",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.questionData.questionDto.questionContent
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "questionEnclosure" }, [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.enclosureUlShow,
                          expression: "enclosureUlShow"
                        }
                      ],
                      staticClass: "enclosureUl"
                    },
                    _vm._l(_vm.questionEnclosure, function(item, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "questionEnclosureItem" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "enclosurePopoverLabel",
                              attrs: { title: item.name },
                              on: {
                                click: function($event) {
                                  return _vm.handlePreview(item.newAttaUrl)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "el-icon-download enclosureDown",
                            on: {
                              click: function($event) {
                                return _vm.handleImport(item.id)
                              }
                            }
                          })
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.questionEnclosure.length &&
                            !_vm.enclosureUlShow,
                          expression:
                            "questionEnclosure.length && !enclosureUlShow"
                        }
                      ],
                      staticClass: "questionEnclosureStyle",
                      on: {
                        dblclick: _vm.dblclick,
                        click: _vm.openQuestionEnclosure
                      }
                    },
                    [
                      _c("span", { staticClass: "el-icon-paperclip" }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "padding-right": "10px",
                            "padding-left": "3px"
                          }
                        },
                        [_vm._v("附件")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "number" }, [
                        _vm._v(_vm._s(_vm.questionEnclosure.length))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.questionEnclosure.length && _vm.enclosureUlShow,
                          expression:
                            "questionEnclosure.length && enclosureUlShow"
                        }
                      ],
                      staticClass: "questionEnclosureStyle"
                    },
                    [
                      _c("span"),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "el-icon-close",
                        staticStyle: { color: "#d2d2d7" },
                        on: {
                          click: function($event) {
                            _vm.enclosureUlShow = false
                          }
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.filePreviewDialog,
            "append-to-body": "",
            "destroy-on-close": "",
            width: "80%",
            top: "7%"
          },
          on: {
            "update:visible": function($event) {
              _vm.filePreviewDialog = $event
            }
          }
        },
        [
          _c("iframe", {
            staticStyle: { width: "100%" },
            style: { height: (_vm.windowHeight / 6) * 4 + "px" },
            attrs: { src: _vm.filePreviewUrl, frameborder: "0" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-717e8e42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-717e8e42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testing/testPaper.vue
// module id = null
// module chunks = 